import http from "./http_common";

class CartOrderService {
  queryString(payload) {
    const QueryString = Object.keys(payload).map((key) => (key && payload[key] && key + "=" + payload[key])).join('&');
    return QueryString;
  }

  AddToCart(data) {
    return http.post(`CartDetails/`, data);
  }

  foreignAddToCart(data) {
    return http.post(`/CartDetails/saveWithoutDp`, data);
  }

  getOrderList(data) {
    var queryString = this.queryString(data);
    return http.get(`/CartDetails/list/filter?${queryString}`);
  }
  
  UpdateCartAddress(data) {
    return http.put(`CartOrderHrd/updateAddress/`, data);
  }

  getOrderHistoryList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/OrderHistory/list?${queryString}`);
  }

  transferCartItems(payload){
    const queryString = this.queryString(payload);
    return http.put(`/CartDetails/?${queryString}`);
  }
}

export default new CartOrderService();
